// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"style-pageContainer-2WVW2","leftWrapper":"style-leftWrapper-1N7r-","pageTitle":"style-pageTitle-bQ4OB","pageDescription":"style-pageDescription-1NrXB"};